import { createFileRoute } from '@tanstack/react-router';
import { ProtectedRoute } from '@org/ui';
import { ConversationTopicsList } from '../app/components/conversation/conversation-topics-list';

export const Route = createFileRoute('/conversation-topics')({
  component: ConversationTopicsRoute,
});

function ConversationTopicsRoute() {
  return (
    <ProtectedRoute requiredPermissions={['admin:all']}>
      <ConversationTopicsList />
    </ProtectedRoute>
  );
}
